import { render } from "./brandConcept.vue?vue&type=template&id=4a7a5b2d"
import script from "./brandConcept.vue?vue&type=script&lang=js"
export * from "./brandConcept.vue?vue&type=script&lang=js"

import "./brandConcept.vue?vue&type=style&index=0&id=4a7a5b2d&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__